// Mix-and-match crew access helpers (content visibility + join policy).
export function crewAccessLabel(cv, jp) {
  if (cv === "members") return "Private";
  if (jp === "open") return "Public";
  if (jp === "request") return "Request to join";
  return "Invite only";
}

export function crewAccessSummary(cv, jp) {
  const vis = cv === "members"
    ? "Posts, media & collabs are hidden until someone joins."
    : "Anyone can view posts, media & collabs.";
  const join = jp === "open"
    ? "Anyone can join instantly."
    : jp === "request"
      ? "People request to join and a manager approves them."
      : "Only owners/managers can invite new members.";
  return `${vis} ${join}`;
}

export function joinButtonLabel(jp) {
  if (jp === "request") return "Request to Join";
  if (jp === "invite") return "Invite only";
  return "Join Crew";
}
